import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { useAuth } from '../contexts/AuthContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash || '';
    const params = new URLSearchParams(hash.replace(/^#/, ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }

    // Preserve any referral code stashed before redirect (used for new signups)
    const referralCode = sessionStorage.getItem('pending_referral_code') || null;

    (async () => {
      try {
        const { data } = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId, referral_code: referralCode },
          { withCredentials: true }
        );
        sessionStorage.removeItem('pending_referral_code');

        // Clear the hash so refresh doesn't retrigger
        window.history.replaceState(null, '', window.location.pathname);

        await checkAuth();

        if (data?.is_new || !data?.questionnaire_completed) {
          toast.success('Welcome to Stable Stationary!');
          navigate('/questionnaire', { replace: true, state: { user: data } });
        } else {
          toast.success(`Welcome back, ${data.name?.split(' ')[0] || ''}`);
          navigate('/dashboard', { replace: true, state: { user: data } });
        }
      } catch (err) {
        console.error('Auth callback failed:', err);
        toast.error('Sign-in failed. Please try again.');
        navigate('/login', { replace: true });
      }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-[#F9F7F3] flex items-center justify-center" data-testid="auth-callback-loading">
      <div className="text-center">
        <div className="inline-block w-8 h-8 border-2 border-[#B94A3E] border-t-transparent rounded-full animate-spin mb-4"></div>
        <p className="text-sm text-[#737373]" style={{ fontFamily: 'Spectral, serif' }}>Signing you in…</p>
      </div>
    </div>
  );
}
